import { useState } from 'react';

interface UseCopyToClipboardReturn {
    copied: boolean;
    copyToClipboard: (text: string) => Promise<boolean>;
    resetCopied: () => void;
}

export const useCopyToClipboard = (resetDelay: number = 2000): UseCopyToClipboardReturn => {
    const [copied, setCopied] = useState(false);

    const copyToClipboard = async (text: string): Promise<boolean> => {
        try {
            if (navigator?.clipboard?.writeText) {
                await navigator.clipboard.writeText(text);
            } else {
                // Fallback for browsers that don't support clipboard API
                const textArea = document.createElement('textarea');
                textArea.value = text;
                textArea.style.position = 'absolute';
                textArea.style.left = '-999999px';
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
            }

            setCopied(true);

            // Reset after the specified delay
            setTimeout(() => {
                setCopied(false);
            }, resetDelay);

            return true;
        } catch (error) {
            console.error('Error copying to clipboard:', error);
            setCopied(false);
            return false;
        }
    };

    const resetCopied = () => {
        setCopied(false);
    };

    return {
        copied,
        copyToClipboard,
        resetCopied
    };
}; 